// extracted by mini-css-extract-plugin
export var pillWrapper = "_y6-0";
export var showOverflow = "_y6-1";